export const formatDateToDDMMYYYY = (isoDateString: string, useShortMonth: boolean = false) => {
    const date = new Date(isoDateString); // Convert ISO string to Date object
    const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with leading zero if necessary
    const fullMonthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ]; // Full month names
    const shortMonthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ]; // Short month names
    const month = useShortMonth
        ? shortMonthNames[date.getMonth()]
        : fullMonthNames[date.getMonth()]; // Decide which name to use
    const year = date.getFullYear(); // Get full year
    return useShortMonth ? `${day} ${month}` : `${day} ${month} ${year}`; // Return in dd Month yyyy format
}

export const divideArray = (arr: any) => {
    const midIndex = Math.ceil(arr.length / 2); // Handle odd-length arrays
    const firstHalf = arr.slice(0, midIndex); // First half of the array
    const secondHalf = arr.slice(midIndex);   // Second half of the array
    return { firstHalf, secondHalf };
}